import { render, staticRenderFns } from "./GraficoClassificacao.vue?vue&type=template&id=4ab79400"
import script from "./GraficoClassificacao.vue?vue&type=script&lang=js"
export * from "./GraficoClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports